import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { addConditionToDb } from 'store/localDb';
import { getCurrentUserId, addCondition } from 'store/storeValtio';
import moment from 'moment';
import './condition.css';
import { getNowISO } from 'helpers/generalHelpers';

export default function Tremors() {
  console.log('Tremors');
  const navigate = useNavigate();
  const currentUserId = getCurrentUserId();

  const [submitting, setSubmitting] = useState(false);
  const [tremorState, setTremorState] = useState(null);

  const tremors = [
    {where: 'Left Hand', code: 'LH'},
    {where: 'Right Hand', code: 'RH'},
    {where: 'Left Leg', code: 'LL'},
    {where: 'Right Leg', code: 'RL'},
    {where: 'Face', code: 'FA'},
  ];

  const tremorSeverity = [
      'Mild',
      'Medium',
      'Strong',
      'Severe',
  ];
 
  useEffect(() => {
    const ts = new Array(tremors.length*4).fill(0);
    setTremorState(ts);
  }, [])
  
  function handleTremor(e) {
    //console.log('handleTremor', e.target.id);
    const ix = parseInt(e.target.id);
    //const iy = ix % 4;
    //const iz = ~~(ix / 4);
    //console.log(ix, iy, iz);

    let ts = [...tremorState];
    //console.log(ix, ts[ix]);
    ts[ix] = ts[ix] > 0 ? 0 : 1;
    setTremorState(ts);
  }

  const initialValues = {
    userId: currentUserId,
    date: getNowISO(),
    type: 'tremors',
    condition: '',
  };


  async function handleSubmit() {
    setSubmitting(true);
    //console.log('submit feelings');
    let t = '';
    for ( let ix=0; ix<tremorState.length; ++ix) {
        const six = ix % 4;
        const tix = ~~(ix / 4);
        const ts = tremorState[ix];
        const tn = tremors[tix].code;
        //console.log(ix, ts, tn);
        if (ts > 0) t = t + tn + ':' + tremorSeverity[six] + ',';
    }
    //console.log('t', t);

    initialValues.date = getNowISO();
    initialValues.condition = t;
    console.log('addCondition', initialValues);
    await addConditionToDb(initialValues);
    addCondition(initialValues);
    setSubmitting(false);
    navigate('/historyTabs/cond');  // do this to refresh
  }

  //console.log(moodState);
  //console.log(tremorState);

return (
    <div className='mcard'>
      <div className='mcard-header'>How are your tremors?</div>
      <div className='flex flex-col mx-2'>
          {tremors.map((t,ix) => {
            return ( <div key={ix} className='tremors flex flex-row py-1 justify-center items-center'>
                <label className='w-4/12 font-semibold'>
                  {t.where}
                </label>
                <ul className='flex flex-row justify-around'>
                    <li 
                      className={`${tremorState && tremorState[ix*4+0] ? 'bg-gray-300' : ''}`}
                      id={`${ix*4+0}`} 
                      onClick={handleTremor}>Mild</li>
                    <li 
                      className={`${tremorState && tremorState[ix*4+1] ? 'bg-gray-300' : ''}`}
                      id={`${ix*4+1}`} 
                      onClick={handleTremor}>Medium</li>
                    <li 
                      id={`${ix*4+2}`} 
                      className={`${tremorState && tremorState[ix*4+2] ? 'bg-gray-300' : ''}`}
                      onClick={handleTremor}>Strong</li>
                    <li 
                      id={`${ix*4+3}`} 
                      className={`${tremorState && tremorState[ix*4+3] ? 'bg-gray-300' : ''}`}
                      onClick={handleTremor}>Severe</li>
                </ul>
              </div>
            )})
          }
      </div>

      <div className='mcard-title mt-10 justify-center'>
          <button
            className='hpBtn'
            onClick={handleSubmit}
            disabled={submitting}
            type='submit'
          >
            Add Feelings (Tremors)
          </button>
        </div>

    </div>
  )
}
